import { render, staticRenderFns } from "./DefaultTabs.vue?vue&type=template&id=f348e85c&scoped=true&"
import script from "./DefaultTabs.vue?vue&type=script&lang=js&"
export * from "./DefaultTabs.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTabs.vue?vue&type=style&index=0&id=f348e85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f348e85c",
  null
  
)

export default component.exports